// A route handler is called when a matching route is navigated or resolved (when the online app router's navigate or resolve methods are called).
// These handler functions are bound to an OnlineApp instance - so `this` refers to the online app.
// Each handler's primary job is to dispatch actions (via the online app's state machine) and thru these actions set the app's state.
// There should be little logic in each handler - just interpret the route data and pass relevant results to a state machine action.

export const rootRouteHandler = function(match) {
    console.log('rootRouteHandler', match);
    // The root route is only requested when the app is first loaded.
    // The Nav will handle this situation and trigger a "click" event on the default nav option (see `Nav` class and the `renderInitial` method).
    // Therefore no action is needed here.
}

export const subpageRouteHandler = function(match) {
    console.log('subpageRouteHandler', match)
    const onlineApp = this;

    const subpage = getSubpageFromSlug(onlineApp, match);

    this.dispatchAction('subpageRouteRequested', subpage);
}

export const filterRouteHandler = function(match) {
    console.log('filterRouteHandler', match)
    const onlineApp = this;

    const mapFilter = getMapFilterFromSlug(onlineApp, match);

    this.dispatchAction('filterRouteRequested', mapFilter);
}

export const filterExperienceRouteHandler = function(match) {
    console.log('filterExperienceRouteHandler', match)
    const onlineApp = this;

    const requestedMapFilter = getMapFilterFromSlug(onlineApp, match);
    const experience = getExperienceFromSlug(onlineApp, match);

    // Reveal-resolver: pick a backdrop filter that actually contains the experience (preferring
    // a specific filter over the broad Everything view), so a place that is not in the requested
    // filter — e.g. the ~1,070 not in Everything — is still shown. Falls back to an ad-hoc pin on
    // the Everything backdrop for the ~58 experiences in no published nav filter.
    // See plans/2026-07-27--experience-navigation-beyond-everything-filter.md.
    const resolution = onlineApp.mapFilterCollection.resolveForExperience(experience, requestedMapFilter);
    const mapFilter = resolution ? resolution.mapFilter : requestedMapFilter;
    const adHoc = resolution ? resolution.adHoc : false;

    console.log('requested mapFilter', requestedMapFilter, 'resolved mapFilter', mapFilter, 'adHoc', adHoc);
    console.log('matched experience', experience);

    this.dispatchAction('filterExperienceRouteRequested', { mapFilter: mapFilter, experience: experience, adHoc: adHoc });
}

export const experienceRouteHandler = function (match) {
    console.log('experienceRouteHandler', match);
    const onlineApp = this;

    const experience = getExperienceFromSlug(onlineApp, match);

    console.log('matched experience', experience);

    // Create this action if necessary…
    // if (experience) { this.dispatchAction('experienceRouteRequested', { experience: experience }) }
}


// Private…

function getSubpageFromSlug(onlineApp, match) {
    const slug = match.data['subpage_id'];
    return onlineApp.subpageCollection.withSlug(slug);
}

function getMapFilterFromSlug(onlineApp, match) {
    const slug = match.data['filter_id'];
    return onlineApp.mapFilterCollection.withSlug(slug);
}

function getExperienceFromSlug(onlineApp, match) {
    const slug = match.data['experience_id'];
    return onlineApp.experienceCollection.withSlug(slug);
}